'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './violations-code-list.routes';

export class ViolationsCodeListComponent {
  constructor(Auth, ViolationCodesService, dialogs, DTOptionsBuilder, DTState) {
    'ngInject';

    this.ViolationCodesService = ViolationCodesService;
    this.data = [];

    this.dialogs = dialogs;

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'desc'])
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save())
      .withOption('stateLoadCallback', DTState.restore())
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      .withOption('buttons',[{
        extend: 'excel',
        title: "CC&R Codes"
      },{
        extend: 'csv',
        title: "CC&R Codes"
      },{
        title: "CC&R Codes",
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'portrait',
        pageSize: 'LETTER'
      },{
        extend: 'print',
        title: "CC&R Codes"
      }]);

    this.ViolationCodesService.query((data) => {
      this.data = data;
      this.dataInitComplete = true;
    }, err => {
      console.log("Could not retrieve violation codes.")
    });
  }

  delete(code) {
    var that = this;

    var codeText = "<br/><br/><b>" + code.code + ': ' + code.name + "</b><br/><p>" + code.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Violation Code?", "Do you really want to delete the violation code?" + codeText);
    dlg.result.then(() => {
      // OK delete it
      that.ViolationCodesService.delete({id: code._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== code._id;
          });
        },
        err => {
          alert("Could not delete violation code");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduu.violationCodeList', [uiRouter])
  .config(routes)
  .component('violationCodeList', {
    template: require('./violations-code-list.html'),
    controller: ViolationsCodeListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/violations/code-list/violations-code-list.component.js